import { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '@/lib/api';

const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    site_title: 'The Ace - Art, Events, Studio',
    contact_phone: '055-9995685',
    contact_email: 'studio@theace.co.il',
    hero_subtitle: 'Precision laser engraving meets digital innovation.',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await settingsAPI.getAll();
      setSettings(res.data);
    } catch (err) {
      console.error('Failed to load settings:', err);
      // Keep default values on error
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
}
